module.exports = __webpack_public_path__ + "static/media/kline_candle.2956c855.svg";